import {ngAsync} from 'shared/utils/ng-@decorators';
import type LoginService from './login.service';
import type RegistrationService from './registration.service';
import type WalkerService from '../commons/services/walker.service';
import type LoginDataService from './kp-login/kp-login.data-service';
import type ActionRequestService from '../commons/services/action-request.service';
import {actionRequestMethods} from '../commons/constants/portaro.constants';

export default class AuthPairingController {
    public static controllerName = 'AuthPairingCtrl';

    public showFullRegistration;

    /*@ngInject*/
    constructor(private loginDataService: LoginDataService,
                private loginService: LoginService,
                private walker: WalkerService,
                private registrationService: RegistrationService,
                private actionRequestService: ActionRequestService) {
        this.init();
    }

    @ngAsync()
    public async init() {
        const loginView = await this.loginDataService.getLoginView();
        this.showFullRegistration = loginView.showFullRegistration;
    }

    @ngAsync()
    public async mergeToAuthenticatedInternalUser() {
        await this.actionRequestService.action('/api/auth/pair-with-current-auth', actionRequestMethods.POST, {});
        return this.walker.newPage('/');
    }

    @ngAsync()
    public async saveNewReader() {
        await this.registrationService.savePersonByForm({}, null);
        return this.walker.newPage('/');
    }

    @ngAsync()
    public async logout() {
        return this.loginService.logout('/');
    }
}